import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-transit-barnameh',
  templateUrl: './transit-barnameh.component.html',
  styleUrls: ['./transit-barnameh.component.css']
})

export class TransitBarnamehComponent implements OnInit {

  lst_GeoFence: any = [];

  lst_Routes: any = [];

  lst_Search: any = [];

  lstCars = [];

  lstMobileType = [];

  bEditMode: boolean = false;

  showFilter: boolean = false;

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    ID: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    iSDGeoFence: new FormControl('-1'),

    iSGeoFence: new FormControl('-1'),

    iDGeoFence: new FormControl('-1'),

    tiResultTrip: new FormControl('-1'),

    tiMobileType: new FormControl('-1'),

    tiTripStatus: new FormControl('-1'),

    tiLoadImportance: new FormControl('-1'),

  });

  mdl_Request: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTransit_Trip: new FormControl(''),

    strDate: new FormControl('', Validators.required),

    iSGeoFence: new FormControl('', Validators.required),

    iDGeoFence: new FormControl('', Validators.required),

    strUnitID: new FormControl('', Validators.required),

    tiLoadImportance: new FormControl('', Validators.required),

    iStandardTime: new FormControl('', Validators.required),

    iStandardStop: new FormControl('', Validators.required),

    strLoadDetail: new FormControl(''),

    strClientMobile: new FormControl(''),

    strLoadNo: new FormControl(''),

    iRent: new FormControl(''),

    strComment: new FormControl(''),

    _i: new FormControl(''),

  });

  mdl_View: FormGroup = this._formBuilder.group({

    iTransit_Trip: new FormControl(''),

    strUnitID: new FormControl(''),

    strDate: new FormControl(''),

    iSGeoFence: new FormControl(''),

    iDGeoFence: new FormControl(''),

    strLoadDetail: new FormControl(''),

    tiLoadImportance: new FormControl(''),

    iStandardTime: new FormControl(''),

    iStandardStop: new FormControl(''),

    strClientMobile: new FormControl(''),

    strLoadNo: new FormControl(''),

    iRent: new FormControl(''),

    strComment: new FormControl(''),

    strLoadingTime: new FormControl(''),

    strDischargeTime: new FormControl(''),

    strReceiverComment: new FormControl(''),

    strSEntryDateTime: new FormControl(''),

    strSExitDateTime: new FormControl(''),

    strSDuration: new FormControl(''),

    strDEntryDateTime: new FormControl(''),

    strDExitDateTime: new FormControl(''),

    strDDuration: new FormControl(''),

    iTripKm: new FormControl(''),

    strResultTime: new FormControl(''),

    iStops: new FormControl(''),

    strStopsTime: new FormControl(''),

    strTripStatus: new FormControl(''),

    iAverageSpeed: new FormControl(''),

    strResultTrip: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    this.getMobileType();

    this.getGeoFence();

    this.getCars();

    this.seach_barnameh();

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  getMobileType = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`GetMobileType_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstMobileType = res;

  }

  getGeoFence = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GeoFence = res;

  }

  getCars = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = (await axios.post(`FleetYar_Car_List_New`, this._other.stringNumberToNumber(model))).data;

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstCars = res;

  }

  seach_barnameh = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Transit_Trip_Search`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Routes = res;

    this.lst_Search = res;

  }

  addRequest(item: any = {}, index?: number) {

    if (item.iTransit_Trip) {

      this.bEditMode = true;

      Object.keys(item).forEach(key => {

        this.mdl_Request.get(key)?.setValue(item[key])

      })

      this.mdl_Request.get('_i')?.setValue(index);

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#addModal").modal("show")

    }

    else {

      this.bEditMode = false;

      this.mdl_Request.patchValue({

        iTransit_Trip: '',

        strUnitID: '',

        strDate: moment().format('jYYYY/jMM/jDD'),

        iSGeoFence: '',

        iDGeoFence: '',

        strLoadDetail: '',

        tiLoadImportance: '',

        iStandardTime: '',

        iStandardStop: '',

        strClientMobile: '',

        strLoadNo: '',

        iRent: '',

        strComment: '',

        _i: '',

      });


      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#addModal").modal("show")

    }

  }

  viewRequest(item) {

    Object.keys(item).forEach(key => {

      this.mdl_View.get(key)?.setValue(item[key]);

    })

    this.mdl_View.disable();

    $("#viewModal").modal("show");


  }

  openMap(item) {

    window.open(`/tracker/${item.strUnitID}`, '_blank');

  }

  submitRequest = async () => {

    if (this.mdl_Request.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    if (!this.bEditMode) {

      let model = this.mdl_Request.value;

      this._other.Showspinner()

      let res = JSON.parse((await axios.post(`Transit_Trip_Save`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Routes.push(res[0]);

      $("#addModal").modal("hide")

      this._tooltip.showSuccess('با موفقیت ذخیره شد');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._other.Showspinner()

              let res = JSON.parse((await axios.post(`Transit_Trip_Edit`, this._other.stringNumberToNumber(this.mdl_Request.value))).data.toString());

              this._other.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Routes[this.mdl_Request.get('_i')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#addModal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }


  }

  removeTransit(item: any, index: number) {

    let model = this._other.stringNumberToNumber({

      ...this.mdl_Request.value,

      iTransit_Trip: item.iTransit_Trip

    })

    $.confirm({

      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            const resp = await axios.post('Transit_Trip_Delete', model);

            this._other.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.lst_Routes.splice(index, 1);

            this.lst_Search = this.lst_Routes;

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  filter_Result(val: any) {

    this.lst_Routes = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strSGeoFence_strTitle.includes(val.value) ||

        el.strDGeoFence_strTitle.includes(val.value)
    });

    if (val.value.length == 0) {

      this.lst_Routes = this.lst_Search;

    }

  }

  updateStatus = async (item, index) => {

    let model = this._other.stringNumberToNumber({

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      iTransit_Trip: item.iTransit_Trip

    })

    $.confirm({

      title: `آیا از تغییر وضعیت اطمینان دارید؟ `,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            const resp = await axios.post('Transit_Trip_ChangeTripStatus', model);

            this._other.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            this._tooltip.showSuccess("با موفقیت ویرایش شد");

            this.lst_Routes[index] = resParse[0];

            this.lst_Search = this.lst_Routes;

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  setValue_Filter(event: any) {

    if (!event.strUnitID && event.strUnitID != 0) {

      this.mdl_Request.controls['strUnitID'].setValue('')

    }

    else {

      this.mdl_Request.controls['strUnitID'].setValue(event.strUnitID);

      if (this.mdl_Request.get('strUnitID')?.value == 0) {

      }

    }

  }

  showTripRoute(item: any) {

    if (item.strSExitDateTime && item.strDEntryDateTime) {

      window.open(`route/${item.strUnitID}`, '_blank')

      window.localStorage.setItem("RouteDate", this._gurd.encrypt(item.strSExitDateTime.split(" ")[0]));

      window.localStorage.setItem("reportStime", this._gurd.encrypt(item.strSExitDateTime.split(" ")[1]));

      window.localStorage.setItem("reportEtime", this._gurd.encrypt(item.strDExitDateTime.split(" ")[1]));

      window.localStorage.setItem("UnitID", this._gurd.encrypt(item.strUnitID.toString()));

      window.localStorage.setItem("carName", this._gurd.encrypt(item.strFullName.toString()));

      window.localStorage.setItem("plate", this._gurd.encrypt(item.strVehicleNo.toString()));

    }

    else {

      return this._tooltip.showError('نتیجه ای یافت نشد.')

    }

  }

  calcTripDuration = async () => {

    const iSGeoFence = this.mdl_Request.get('iSGeoFence')?.value;

    const iDGeoFence = this.mdl_Request.get('iDGeoFence')?.value;

    if (!iSGeoFence || !iDGeoFence || iSGeoFence == '' || iDGeoFence == '' || iSGeoFence == '-1' || iDGeoFence == '-1') {

      return this._tooltip.showError('لطفا مبدا و مقصد را انتخاب کنید');

    }

    let model = this._other.stringNumberToNumber({

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

      iSGeoFence: iSGeoFence,

      iDGeoFence: iDGeoFence

    });

    try {

      this._other.Showspinner();

      const resp = await axios.post(`Transit_Trip_CalKmDuration`, model);

      this._other.nonespinner();

      let res: any = resp.data;

      if (typeof res === 'string') {

        try { res = JSON.parse(res); } catch (e) { }

      }

      if (res && typeof res.data === 'string') {

        try { res = JSON.parse(res.data); } catch (e) { }

      }

      if (res && res.iResult == 0) return this._tooltip.showError(res.strError || 'خطا در محاسبه');

      let data: any = Array.isArray(res) ? res[0] : res;

      if (data && data.data) {

        data = Array.isArray(data.data) ? data.data[0] : data.data;

      }

      const fKm = data?.fKm ?? data?.fKM ?? data?.fkm ?? res?.fKm ?? '-';

      const strTime = data?.iHour ?? '-';

      $.confirm({

        title: 'نتیجه محاسبه مسیر',

        content: `<div style="direction:rtl;text-align:right;line-height:2.2;font-size:14px;">` +

          `<div><strong>مسافت (کیلومتر):</strong> <span style="color:#0d6efd;">${fKm}</span></div>` +

          `<div><strong>برآورد مدت سفر (ساعت):</strong> <span style="color:#0d6efd;">${strTime}</span></div>` +

          `</div>`,

        type: 'blue',

        columnClass: 'col-12 col-md-6 col-md-offset-3',

        buttons: {

          apply: {

            text: 'اعمال به مدت استاندارد',

            btnClass: 'btn-primary',

            action: () => {

              if (strTime !== '-' && strTime !== undefined && strTime !== null && strTime !== '') {

                this.mdl_Request.get('iStandardTime')?.setValue(strTime);

              }

            }

          },

          close: {

            text: 'بستن',

            btnClass: 'btn-outline-secondary',

          }

        }

      });

    } catch (e: any) {

      this._other.nonespinner();

      this._tooltip.showError('خطا در ارتباط با سرور');

    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._other.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'بارنامه.xlsx');
  }


}
